@if(notification){
<fuse-alert [type]="notification.type" [appearance]="'outline'" [dismissible]="true" [dismissed]="false"
    class="font-semibold text-sm validator-alert" @fadeIn>
    {{notification.message}}
</fuse-alert>
}